/**
 * extractBaseDomain - extracts a base domain from a full domain
 *
 * @param domainIn - e.g. one.untangl.co.uk
 * @return {*|string|*} - e.g. untangl.co.uk
 * @private
 */
function extractBaseDomain(domainIn: string) {
  const domainRXone = /^admin\.(\w+(?:\.\w+)*)$/;
  const r = domainIn.match(domainRXone);
  //log.debug("{_extractBaseDomain} match gives", r);
  if (r == null) {
    return domainIn; //cannot detect any subdomain
  }
  return (r.length === 2) ? r[1] : domainIn;
}

export { extractBaseDomain };
